import {Dot} from '../components/routeSelector';
import DirectionsResult = google.maps.DirectionsResult;
import LatLngBounds = google.maps.LatLngBounds;
export default {
    
    
          
    buildStaticImage(key: string, line: string) {
        return 'https://maps.googleapis.com/maps/api/staticmap?' +
            'size=400x400&' +
            'path=' +
            'weight:10%7C' +
            'color:blue%7C' +
            `enc:${line}&` +
            `key=${key}`
    },

    getDirections(origin: Dot, destiny: Dot, region: string): Promise<DirectionsResult> {
        const service = new google.maps.DirectionsService();
        
        return new Promise((resolve, reject) => {
            service.route({
                origin: new google.maps.LatLng(origin.lat, origin.lng),
                destination: new google.maps.LatLng(destiny.lat, destiny.lng),
                travelMode: google.maps.TravelMode.DRIVING,
                region: region, 
            }, (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    resolve(result);
                } else {
                    reject({
                        msg: result,
                        status: status
                    });
                }
            });
        });
    },

    getGeoCodeBounds(region: string): Promise<LatLngBounds>{
        const service = new google.maps.Geocoder();
        return new Promise((resolve, reject)=>{
            service.geocode({ 
                    address: region 
                }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    resolve(results[0].geometry.bounds);
                } else {
                    reject({
                        msg: results,
                        status: status
                    });
                }
                
            });
        } );
    }


}


// WEBPACK FOOTER //
// ./src/api/googleMaps.ts